import Calendar from "./calendar";
import Certificate from "./certificate";
import Notify from "./../notify";

export default class Payment {
    constructor() {
        this.navigation = {
            step1: "payment-step-1",
            step2: "payment-step-2",
            step3: "payment-step-3",
            step4: "payment-step-4",
        };
        this.controllElements = {
            containerDate: "container-date",
            stepButton1: "payment-step-next-1",
            stepPrevButton1: "payment-step-prev-1",
            stepContainer1: "payment-step-container-1",
            stepContainer2: "payment-step-container-2",
            stepContainer3: "payment-step-container-3",
            stepContainer4: "payment-step-container-4",
            flagSuccess1: "",
            flagSuccess2: "",
            flagSuccess3: "",
            flagSuccess4: "",
        };
        (this.eventCallendar = "payment-calendar"), (this.formId = "payment");
        this.flagCert = "";
        this.flagTicket = "";
        this.userData = {
            name: "",
            phone: "",
            email: "",
            sessionDay: "",
            sessionYear: "",
            sessionMounth: "",
            sessionTime: "",
            sessionTimeId: "",
            sessionPrice: "",
            resultPrice: 0,
            sessionService: [],
            sessionPlaceCount: "",
            linkTour: "",
            thanksLink: "",
            sessionRemains: "",
        };
        this.eventId = $("#payment").attr("data-item");
        this.dataForm = {};
        this.russianMounth = [
            "января",
            "февраля",
            "марта",
            "апреля",
            "мая",
            "июня",
            "июля",
            "августа",
            "сентября",
            "октября",
            "ноября",
            "декабря",
        ];
        this.windowPay = "";
        this.countTimes = 0;
    }

    calcResultPrice() {
        this.userData.resultPrice =
            Number(this.userData.sessionPrice) *
            Number(this.userData.sessionPlaceCount);
        if (this.userData.sessionService.length > 0) {
            for (let i = 0; i < this.userData.sessionService.length; i++) {
                this.userData.resultPrice +=
                    Number(this.userData.sessionService[i].price) *
                    Number(this.userData.sessionService[i].count);
            }
        }
    }

    reculcResultPrice() {
        this.calcResultPrice();

        $("#resultPrice").html(
            Number(this.userData.resultPrice).toLocaleString("ru")
        );
    }

    checkStep1() {
        let requiredFlag = false;

        let inputs = $("#" + this.controllElements.stepContainer1).find(
            'input[type="text"],input[type="email"], input[type="phone"]'
        );

        if (inputs.length > 0) {
            for (let i of inputs) {
                if ($(i).attr("data-required") == "Y") {
                    if (!$(i).val().trim() || $(i).val().length == 0) {
                        $(i).addClass("callout alert");

                        requiredFlag = true;
                    } else {
                        $(i).removeClass("callout alert");
                    }
                }
                let name = $(i).attr("name");
                let value = $(i).val().trim();
                this.userData[name] = value;
            }
        }

        if ($("[name='phone']").inputmask("isComplete")) {
            $("[name='phone']").removeClass("callout alert");
        } else {
            requiredFlag = true;
            $("[name='phone']").addClass("callout alert");
        }

        if (this.emailValidate($("[name='email']").val())) {
            $("[name='email']").removeClass("callout alert");
        } else {
            requiredFlag = true;
            $("[name='email']").addClass("callout alert");
        }

        //  проверка чекбоксов
        let agreeOffer = $("[name='agree-offer']");
        let agreeConf = $("[name='agree-conf']");

        if (!agreeOffer.prop("checked")) {
            requiredFlag = true;

            if ($("#alert-agree-offer").length <= 0) {
                agreeOffer
                    .parent()
                    .before(
                        "<p  class='callout alert' id='alert-agree-offer'>Необходимо принять условия оферты</p>"
                    );
            }
        } else {
            $("#alert-agree-offer").detach();
        }
        if (!agreeConf.prop("checked")) {
            requiredFlag = true;
            if ($("#alert-agree-conf").length <= 0) {
                agreeConf
                    .parent()
                    .before(
                        "<p  class='callout alert' id='alert-agree-conf'>Необходимо согласие с политикой конфиденциальности</p>"
                    );
            }
        } else {
            $("#alert-agree-conf").detach();
        }

        if (!requiredFlag) {
            return true;
        } else return false;
    }

    showStep1() {
        $("#" + this.navigation.step3).removeClass("sect_dark");
        // $(".cert-container").addClass("hide");
        this.initCallendar();
        $("#" + this.controllElements.stepContainer1).removeClass("hide");
        $("#" + this.controllElements.stepContainer1).show();
    }

    hideStep1() {
        $("#" + this.navigation.step3).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer1).hide();
    }

    showStep2() {
        $("#" + this.navigation.step1).removeClass("sect_dark");
        this.initCallendar();
        $("#" + this.controllElements.stepContainer2).show();
        // $(".cert-container").removeClass("hide");
    }

    hideStep2() {
        $("#" + this.navigation.step1).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer2).hide();
    }

    showStep3() {

        let instance = this;
        instance.countTimes = 0;
        let times = this.getTimesForSession();
        for (var t in times) {
            instance.countTimes++;
        }

        if (instance.countTimes == 1) {
            instance.userData.sessionDay = times[instance.countTimes].day;
            instance.userData.sessionMounth = times[instance.countTimes].mounth;
            instance.userData.sessionYear = times[instance.countTimes].year;
            instance.userData.sessionTime = times[instance.countTimes].time;
            instance.userData.sessionTimeId = times[instance.countTimes].id;
            instance.hideStep3();
            instance.showStep1();
            return true;
        }


        let container = $("#" + this.controllElements.stepContainer3);

        $("#" + this.navigation.step3).addClass("sect_dark");
        $("#" + this.navigation.step2).removeClass("sect_dark");
        // $(".cert-container").addClass("hide");
        let dateContent = document.createElement("p");
        let dateDays = document.createElement("b");
        dateDays.innerHTML =
            this.userData.sessionDay +
            " " +
            this.russianMounth[this.userData.sessionMounth - 1] +
            " " +
            this.userData.sessionYear +
            " " +
            "&nbsp; &nbsp;";

        let buttonDate = document.createElement("a");
        buttonDate.innerHTML = "Сменить дату";
        buttonDate.addEventListener("click", function(e) {
            e.preventDefault();
            instance.hideStep3();
            instance.showStep2();
        });
        let br = document.createElement("br");
        br.classList.add("hide-for-medium");
        dateContent.appendChild(dateDays);
        dateContent.appendChild(br);
        dateContent.appendChild(buttonDate);
        $("#" + this.controllElements.containerDate).html(dateContent);

        let content = document.createElement("div");

        let nameSection = document.createElement("div");
        nameSection.classList.add("sect", "text-center");
        nameSection.innerHTML = "<b>Выберите время участия</b>";



        let calendarTimes = document.createElement("div");
        calendarTimes.classList.add("calendar");
        let calendarRow = document.createElement("div");
        calendarRow.classList.add("calendar-times", "grid-x", "align-center");
        let calendarCell = document.createElement("div");
        calendarCell.classList.add("cell", "medium-6");
        calendarRow.appendChild(calendarCell);
        calendarTimes.appendChild(calendarRow);

        for (let i = 1; i <= Object.keys(times).length; i++) {
            let itemTime = document.createElement("a");
            itemTime.classList.add("calendar-time");

            itemTime.addEventListener("click", function(e) {
                e.preventDefault();
                instance.userData.sessionDay = times[i].day;
                instance.userData.sessionMounth = times[i].mounth;
                instance.userData.sessionYear = times[i].year;
                instance.userData.sessionTime = times[i].time;
                instance.userData.sessionTimeId = times[i].id;
                instance.hideStep3();
                instance.showStep1();
            });
            itemTime.innerHTML = times[i].time;
            calendarCell.appendChild(itemTime);
        }

        let buttonRow = document.createElement("div");
        buttonRow.classList.add("grid-x", "align-justify");

        let buttonCell = document.createElement("div");
        buttonCell.classList.add("cell", "medium-shrink");

        let button = document.createElement("a");
        button.classList.add("button", "hollow", "expanded");
        button.innerHTML = "<i class='fa fa-chevron-left'></i> Предыдущий шаг";
        buttonRow.appendChild(buttonCell);
        buttonCell.appendChild(button);

        button.addEventListener("click", function(e) {
            e.preventDefault();
            instance.hideStep3();
            instance.showStep2();
        });

        content.appendChild(nameSection);
        content.appendChild(calendarTimes);
        content.appendChild(document.createElement("br"));
        content.appendChild(buttonRow);

        container.html(content);

        container.show();
    }

    hideStep3() {
        $("#" + this.controllElements.containerDate).empty();

        $("#" + this.navigation.step2).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer3).hide();
    }

    openWindowPay() {
        this.windowPay = window.open();
    }
    showStep4() {
        this.hideStep2();

        this.userData.sessionService = [];

        let container = $("#" + this.controllElements.stepContainer4);

        let instance = this;

        $("#" + this.navigation.step4).removeClass("sect_dark");

        let dateContent = document.createElement("p");
        let dateDays = document.createElement("b");
        dateDays.innerHTML =
            this.userData.sessionDay +
            " " +
            this.russianMounth[this.userData.sessionMounth - 1] +
            " " +
            this.userData.sessionYear +
            ", " +
            this.userData.sessionTime +
            "&nbsp; &nbsp;";

        let buttonDate = document.createElement("a");
        buttonDate.innerHTML = "Сменить время";
        if (instance.countTimes == 1) {
            buttonDate.innerHTML = "Сменить дату";
        }

        buttonDate.addEventListener("click", function(e) {
            e.preventDefault();
            if (instance.countTimes == 1) {
                instance.hideStep4();
                instance.showStep2();
                return true;
            }
            instance.hideStep4();
            instance.showStep3();
        });
        let br = document.createElement("br");
        br.classList.add("hide-for-medium");
        dateContent.appendChild(dateDays);
        dateContent.appendChild(br);
        dateContent.appendChild(buttonDate);
        $("#" + this.controllElements.containerDate).html(dateContent);

        let content = document.createElement("div");

        let buttonRow = document.createElement("div");

        buttonRow.classList.add("grid-x", "align-justify");

        let buttonCellPrev = document.createElement("div");
        buttonCellPrev.classList.add("cell", "medium-shrink");

        let buttonCellSend = document.createElement("div");
        buttonCellSend.classList.add(
            "cell",
            "medium-shrink",
            "medium-order-2",
            "text-center",
            "medium-text-left"
        );

        let buttonSend = document.createElement("button");
        buttonSend.classList.add("button", "solid", "expanded");
        buttonSend.setAttribute("type", "submit");
        buttonSend.innerHTML = "Оплатить";

        buttonSend.addEventListener("click", function(e) {
            e.preventDefault();
            instance.openWindowPay();

            let payForm = $("#payment");
            payForm.submit();
        });

        let buttonPrev = document.createElement("a");
        buttonPrev.classList.add("button", "hollow", "expanded");
        buttonPrev.innerHTML = "<i class='fa fa-chevron-left'></i> Предыдущий шаг";

        buttonPrev.addEventListener("click", function(e) {

            if (instance.countTimes == 1) {
                instance.hideStep4();
                instance.showStep2();
                return true;
            }

            e.preventDefault();
            instance.hideStep4();
            instance.showStep3();
        });
        buttonCellSend.appendChild(buttonSend);
        buttonRow.appendChild(buttonCellSend);
        buttonRow.appendChild(buttonCellPrev);
        buttonCellPrev.appendChild(buttonPrev);

        let dataTickets = this.getDateTicket();

        this.userData.sessionPrice = dataTickets.price;
        this.userData.linkTour = dataTickets.linkTour;
        this.userData.sessionRemains = dataTickets.remains;
        this.userData.thanksLink = dataTickets.thanksLink;

        let labelPlace = document.createElement("div");
        labelPlace.classList.add("sect");
        labelPlace.innerHTML = "<b>Количество участников</b>";

        let placeInputContainer = document.createElement("div");
        placeInputContainer.classList.add(
            "grid-x",
            "grid-padding-x",
            "align-middle"
        );
        let placeInputCell = document.createElement("div");
        placeInputCell.classList.add("cell", "medium-6");
        let countPlaceInputCell = document.createElement("div");
        countPlaceInputCell.classList.add(
            "cell",
            "medium-auto",
            "text-center",
            "medium-text-left"
        );
        countPlaceInputCell.innerHTML =
            "<p class='help-text'>Доступно " + dataTickets.remains + " мест</p>";
        let spinner = document.createElement("div");
        spinner.classList.add("js-spinner", "input-group");
        let spinnerContainerButtonMinus = document.createElement("div");
        spinnerContainerButtonMinus.classList.add("input-group-button");

        spinnerContainerButtonMinus.innerHTML =
            "<button class='button light-gray' type='button' spinner-button='down'>–</button>";
        let spinnerInput = document.createElement("input");
        spinnerInput.classList.add(
            "input-group-field",
            "textfield",
            "text-center",
            "js-stepper"
        );
        spinnerInput.setAttribute("step", "1");
        spinnerInput.setAttribute("max", "999");
        spinnerInput.setAttribute("min", "0");
        spinnerInput.setAttribute("value", "1");
        spinnerInput.setAttribute("data-stepper-debounce", "400");
        spinnerInput.setAttribute("name", "count-place");
        spinnerInput.setAttribute("type", "number");

        $(spinnerInput).on("change", function() {
            if (this.value == 0) {
                this.value = 1;
            }
            if (this.value || Number(this.value) !== 0) {
                instance.userData.sessionPlaceCount = Number(this.value);
            } else {
                this.value = 1;
            }

            instance.reculcResultPrice();
        });

        this.userData.sessionPlaceCount = 1;

        let spinnerContainerButtonPlus = document.createElement("div");
        spinnerContainerButtonPlus.classList.add("input-group-button");

        spinnerContainerButtonPlus.innerHTML =
            "<button class='button light-gray' type='button' spinner-button='up'>+</button>";

        spinner.appendChild(spinnerContainerButtonMinus);
        spinner.appendChild(spinnerInput);
        spinner.appendChild(spinnerContainerButtonPlus);
        placeInputCell.appendChild(spinner);
        placeInputContainer.appendChild(placeInputCell);
        placeInputContainer.appendChild(countPlaceInputCell);

        let hr = document.createElement("hr");

        let hr2 = document.createElement("hr");

        content.appendChild(hr2);
        content.appendChild(labelPlace);
        content.appendChild(placeInputContainer);
        content.appendChild(hr);

        let labelService = document.createElement("div");
        labelService.classList.add("sect");
        labelService.innerHTML = "<b>Дополнительные услуги</b>";

        if (Object.keys(dataTickets.services).length > 0) {
            content.appendChild(document.createElement("br"));
            content.appendChild(labelService);

            for (let j = 1; j <= Object.keys(dataTickets.services).length; j++) {
                if (dataTickets.services[j]) {
                    let serviceRow = document.createElement("div");
                    serviceRow.classList.add("grid-x", "grid-padding-x");
                    let serviceName = document.createElement("div");
                    serviceName.classList.add("cell", "medium-12", "medium-order-2");
                    serviceName.innerHTML = dataTickets.services[j].name;

                    let serviceSpinnerContainer = document.createElement("div");
                    serviceSpinnerContainer.classList.add(
                        "cell",
                        "small-16",
                        "medium-6",
                        "medium-order-1"
                    );
                    let serviceInputContainer = document.createElement("div");
                    serviceInputContainer.classList.add("js-spinner", "input-group");
                    let servicesSpinnerContainerButtonMinus = document.createElement(
                        "div"
                    );
                    servicesSpinnerContainerButtonMinus.classList.add(
                        "input-group-button"
                    );
                    servicesSpinnerContainerButtonMinus.innerHTML =
                        "<button class='button light-gray' type='button' spinner-button='down'>–</button>";

                    let servicesSpinnerInput = document.createElement("input");
                    servicesSpinnerInput.classList.add(
                        "input-group-field",
                        "textfield",
                        "text-center",
                        "js-stepper",
                        "payment-service-stepper"
                    );
                    servicesSpinnerInput.setAttribute("step", "1");
                    servicesSpinnerInput.setAttribute(
                        "max",
                        dataTickets.services[j].count
                    );
                    servicesSpinnerInput.setAttribute("min", "0");
                    servicesSpinnerInput.setAttribute("value", "0");
                    servicesSpinnerInput.setAttribute("data-stepper-debounce", "400");
                    servicesSpinnerInput.setAttribute("name", "payment-service-" + j);
                    servicesSpinnerInput.setAttribute(
                        "id",
                        "payment-service-" + dataTickets.services[j].id
                    );
                    spinnerInput.setAttribute("type", "number");
                    $(servicesSpinnerInput).on("change", function() {
                        let allservices = document.querySelectorAll(
                            ".payment-service-stepper"
                        );
                        allservices.forEach(function(element, index) {
                            instance.userData.sessionService[index].count = Number(
                                element.value
                            );
                        });
                        instance.reculcResultPrice();
                    });

                    let servicesSpinnerContainerButtonPlus = document.createElement(
                        "div"
                    );
                    servicesSpinnerContainerButtonPlus.classList.add(
                        "input-group-button"
                    );
                    servicesSpinnerContainerButtonPlus.innerHTML =
                        "<button class='button light-gray' type='button' spinner-button='up'>+</button>";

                    let servicePrice = document.createElement("div");
                    servicePrice.classList.add(
                        "cell",
                        "small-8",
                        "medium-6",
                        "medium-order-3",
                        "text-right"
                    );
                    servicePrice.innerHTML =
                        Number(dataTickets.services[j].price).toLocaleString("ru") + " руб";

                    serviceInputContainer.appendChild(
                        servicesSpinnerContainerButtonMinus
                    );
                    serviceInputContainer.appendChild(servicesSpinnerInput);
                    serviceInputContainer.appendChild(servicesSpinnerContainerButtonPlus);
                    serviceSpinnerContainer.appendChild(serviceInputContainer);
                    // let service
                    let br2 = document.createElement("br");
                    br2.classList.add("hide-for-medium");
                    // let br3 = document.createElement("br");
                    // br3.classList.add("hide-for-medium");
                    serviceRow.appendChild(serviceName);
                    serviceRow.appendChild(serviceSpinnerContainer);
                    serviceRow.appendChild(servicePrice);

                    // serviceRow.appendChild(br3);
                    serviceRow.appendChild(servicePrice);

                    content.appendChild(serviceRow);
                    content.appendChild(br2);

                    this.userData.sessionService.push({
                        id: dataTickets.services[j].id,
                        price: dataTickets.services[j].price,
                        count: 0,
                    });
                }
            }
        }

        let br3 = document.createElement("br");
        br3.classList.add("show-for-medium");

        let resultContainer = document.createElement("div");
        resultContainer.classList.add("sect", "grid-x");
        let promoContainer = document.createElement("div");
        promoContainer.classList.add("cell", "medium-12", "large-10");
        let resultPriceContainer = document.createElement("div");
        resultPriceContainer.classList.add(
            "cell",
            "medium-auto",
            "lead",
            "text-right"
        );
        let resultPrice = document.createElement("div");
        resultPrice.classList.add("sect");

        this.calcResultPrice();

        resultPrice.innerHTML =
            "Итого " +
            "<b id='resultPrice'>" +
            Number(this.userData.resultPrice).toLocaleString("ru") +
            "</b>" +
            " руб";

        let promo = document.createElement("div");
        promo.classList.add("search");
        let promoInput = document.createElement("input");
        promoInput.classList.add(
            "textfield",
            "search__input",
            "search__input_border"
        );
        promoInput.setAttribute("name", "promo");
        promoInput.setAttribute("placeholder", "Промокод");
        $(promoInput).inputmask({
            mask: "*{0,10}",
        });

        let promoButtonContainer = document.createElement("div");
        promoButtonContainer.classList.add("search__cont");
        let promoButton = document.createElement("a");
        promoButton.classList.add("button_input", "button");
        promoButton.innerHTML = "Пересчитать";
        promoButton.addEventListener("click", function(e) {
            e.preventDefault();
            console.log("Функция в разработке");
        });

        promo.appendChild(promoInput);
        promoButtonContainer.appendChild(promoButton);
        promo.appendChild(promoButtonContainer);
        promoContainer.appendChild(promo);

        resultPriceContainer.appendChild(resultPrice);
        resultContainer.appendChild(promoContainer);

        resultContainer.appendChild(resultPriceContainer);

        let warningContainer = document.createElement("div");
        warningContainer.classList.add("card");
        let warningRow = document.createElement("div");
        warningRow.classList.add("card-section", "grid-x", "grid-padding-x");
        let warningCellIcon = document.createElement("div");
        warningCellIcon.classList.add("cell", "shrink");
        warningCellIcon.innerHTML = "<i class='fas fa-info-circle'>";
        let warningCellText = document.createElement("div");
        warningCellText.classList.add("cell", "auto");
        warningCellText.innerHTML =
            "Мы забронируем выбранное Вами количество мест и будем ждать оплаты в течение 15 минут. По истечению этого срока, если оплата не внесена, бронь будет автоматически снята.";

        warningRow.appendChild(warningCellIcon);
        warningRow.appendChild(warningCellText);
        warningContainer.appendChild(warningRow);

        content.appendChild(br3);
        content.appendChild(resultContainer);
        content.appendChild(warningContainer);
        content.appendChild(document.createElement("br"));
        content.appendChild(document.createElement("br"));
        content.appendChild(buttonRow);

        container.html(content);

        $(".payment-service-stepper").stepper();
        $(".payment-service-stepper").inputmask({
            mask: "9{0,2}",
        });
        $("input[name='count-place']").stepper();

        container.show();
    }
    hideStep4() {
        $("#" + this.controllElements.containerDate).empty();
        $("#" + this.navigation.step4).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer4).hide();
    }

    getDateTicket() {
        let data = {
            remains: "",
            services: "",
            price: "",
            linkTour: "",
            thanksLink: "",
        };

        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/event_pay.php",
            async: false,
            data: {
                action: "get_product",
                data: {
                    id: this.userData.sessionTimeId,
                },
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);

                if (res.success) {
                    data.price = res.price;
                    data.remains = res.remains;

                    if (res.services) {
                        data.services = res.services;
                    }
                    if (res.linkTour) {
                        data.linkTour = res.linkTour;
                    }

                    if (res.linkThanks) {
                        data.thanksLink = res.linkThanks;
                    }
                }
            },

            error(xhr, status, error) {
                console.log(error);
            },
        });

        return data;
    }

    getTimesForSession() {
        let times = null;

        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/event_pay.php",
            async: false,
            // dataType: 'json',
            data: {
                action: "get_times",
                data: {
                    event: this.eventId,
                    day: this.userData.sessionDay,
                    mounth: this.userData.sessionMounth,
                    year: this.userData.sessionYear,
                },
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);
                if (res.success) {
                    if (Object.keys(res.times).length > 0) {
                        times = res.times;
                    }
                }
            },

            error(xhr, status, error) {
                console.log(error);
            },
        });

        return times;
    }

    initCallendar() {
        if ($("#" + this.controllElements.stepContainer2).length) {
            const calendar = new Calendar(
                this.controllElements.stepContainer2,
                false,
                false,
                this
            );
            calendar.init();
        }

    }

    errorNoCountPlace() {
        let container = document.createElement("div");
        container.classList.add("grid-y");

        let tourLink =
            "<p>Вернуться <a href='" +
            this.userData.linkTour +
            "'>на страницу тура</a></p>";
        container.innerHTML =
            " <div class='cell text-center' style='margin-top:auto;margin-bottom:auto;'>" +
            "<br>" +
            "<div class='flex-container align-center'>" +
            "<div style='max-width: 80ch;'><h1>Вы пытаетесь купить больше мест, чем доступно на сеанс.</h1>" +
            "<div class='sect lead'>Для решения вопроса с Вами свяжется наш менеджер.</div>" +
            "<div class='sect sect_dark'>Обычно, в течение 30 минут. Ежедневно с 09:00 до 21:00</div>" +
            "</div></div><br>" +
            tourLink +
            "<br>" +
            " </div>";

        $("#payment-main-content").html(container);
        // Отправляем   почту менеджеру запрос
        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/event_pay.php",
            data: {
                action: "error_no_place",
                data: this.userData,
            },
            success: function() {},
            error(xhr, status, error) {
                console.log(error);
            },
        });
    }
    sucessOrderTemplate(type) {
        if (type == 1) {
            let container = document.createElement("div");
            container.classList.add("grid-y");
            container.innerHTML =
                " <div class='cell text-center' style='margin-top:auto;margin-bottom:auto;'>" +
                "<br>" +
                "<div class='flex-container align-center'>" +
                "<div style='max-width: 80ch;'><h1>Спасибо! Ваш сертификат забронирован</h1>" +
                "<div class='sect lead'>Ваша бронь будет автоматически снята через 60 минут</div>" +
                "<div class='sect sect_dark'>Пожалуйста, оплатите заказ сейчас или его придётся оформлять заново</div>" +
                "</div></div><br>" +
                " </div>";
            $("#payment-cert-container").html(container);
        } else {
            let container = document.createElement("div");
            container.classList.add("grid-y");
            container.innerHTML =
                " <div class='cell text-center' style='margin-top:auto;margin-bottom:auto;'>" +
                "<br>" +
                "<div class='flex-container align-center'>" +
                "<div style='max-width: 80ch;'><h1>Спасибо! Ваш билет забронирован</h1>" +
                "<div class='sect lead'>Ваша бронь будет автоматически снята через 15 минут</div>" +
                "<div class='sect sect_dark'>Пожалуйста, оплатите заказ сейчас или его придётся оформлять заново</div>" +
                "</div></div><br>" +
                " </div>";
            $("#payment-main-content").html(container);
        }
    }

    orderCancelNotify() {
        let container = document.createElement("div");
        container.classList.add("grid-y");
        container.innerHTML =
            " <div class='cell text-center' style='margin-top:auto;margin-bottom:auto;'>" +
            "<br>" +
            "<div class='flex-container align-center'>" +
            "<div style='max-width: 80ch;'><h1>Бронь успешно снята</h1>" +
            " </div>";

        $("#payment-main-content").html(container);
    }

    checkServiceCount() {
        let requiredFlag = false;
        this.userData.sessionService.forEach((element) => {
            if (element.count > $("#payment-service-" + element.id).attr("max")) {
                $("#payment-service-" + element.id).addClass("callout alert");
                requiredFlag = true;
            } else {
                $("#payment-service-" + element.id).removeClass("callout alert");
            }
        });

        if (!requiredFlag) {
            return true;
        } else return false;
    }

    sendForm() {
        let instance = this;

        $("#payment").on("submit", function(e) {
            e.preventDefault();

            let checkService = instance.checkServiceCount();

            if (
                Number(instance.userData.sessionPlaceCount) >
                Number(instance.userData.sessionRemains)
            ) {
                instance.windowPay.close();
                instance.errorNoCountPlace();
            } else {
                if (checkService == true) {
                    $.ajax({
                        method: "POST",
                        url: "/themes/ahtilahti/ajax/event_pay.php",
                        async: false,
                        data: {
                            action: "set_order",
                            data: instance.userData,
                        },
                        success: function(response) {
                            let res;
                            typeof response === "string" ?
                                (res = $.parseJSON(response)) :
                                (res = response);
                            if (res.success) {
                                instance.pay(res.order);
                            } else {
                                instance.windowPay.close();
                            }
                        },

                        error(xhr, status, error) {
                            instance.windowPay.close();
                            console.log(xhr);
                        },
                    });
                }
            }
        });
    }
    pay(id) {
        let instance = this;
        $.ajax({
            url: "/themes/ahtilahti/ajax/event_pay.php",
            method: "POST",
            async: false,
            data: {
                action: "order_pay",
                data: {
                    id: id,
                },
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);
                if (res.success && res.payUrl) {
                    // console.log(res);
                    if (location.href.indexOf("payment-reminder") != -1) {
                        //
                    } else {
                        instance.sucessOrderTemplate(res.type);
                    }
                    instance.windowPay.location.href = res.payUrl;
                    // window.open(res.payUrl);
                    // ОТКРЫВАЕТСЯ 2 ОКНА
                } else {
                    instance.windowPay.close();
                    new Notify(res.error, "alert");
                }
            },

            error(xhr, status, error) {
                instance.windowPay.close();
                console.log($.parseJSON(xhr.responseText).message);
            },
        });
    }
    orderCancel(id) {
        let instance = this;
        $.ajax({
            url: "/themes/ahtilahti/ajax/event_pay.php",
            method: "POST",
            data: {
                action: "order_cancel",
                data: {
                    id: id,
                },
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);

                if (res.success) {
                    instance.orderCancelNotify();
                }
            },

            error(xhr, status, error) {
                console.log($.parseJSON(xhr.responseText).message);
            },
        });
    }
    hideSteps() {
        $("#payment-nav-steps").hide();
    }
    emailValidate(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    hidePaymentForm() {
        $("#payment").hide();
    }
    init() {
        this.hideStep1();
        this.showStep2();
        let instance = this;

        $("[name='phone']").inputmask({
            mask: "+7 (999) 999-99-99",
        });

        $("#fio").on("input", function() {
            $(this).val(
                $(this)
                .val()
                .replace(/^[^А-Яа-яЁёA-Za-z\-\s]/, "")
            );
        });

        // $(document).on("click", "#buy-cert", function(e) {
        //     e.preventDefault();
        //     let check1 = instance.checkStep1();
        //     if (check1 == true) {
        //         instance.hidePaymentForm();
        //         instance.hideSteps();
        //         const cert = new Certificate();
        //         let form = document.getElementById(cert.formCertId);
        //         if (form) {
        //             cert.init();
        //             cert.userdata["name"] = instance.userData.name;
        //             cert.userdata["phone"] = instance.userData.phone;
        //             cert.userdata["email"] = instance.userData.email;
        //         }
        //     }
        // });

        $(document).on("click", "#" + this.controllElements.stepButton1, function(
            e
        ) {
            e.preventDefault(e);
            let check1 = instance.checkStep1();
            if (check1 == true) {
                instance.hideStep1();
                instance.showStep4();
            }
        });

        $(document).on("click", "#" + this.controllElements.stepPrevButton1, function(
            e
        ) {
            e.preventDefault();
            if (instance.countTimes == 1) {
                instance.hideStep1();
                instance.showStep2();
            } else {
                instance.hideStep1();
                instance.showStep3();
            }

        });


        instance.sendForm();
    }
}

(function() {

    if ($("#payment").length || $("#payment-reminder").length) {

        const pay = new Payment();
        pay.init();

        $("#payment-pay-order").on("click", function(e) {
            e.preventDefault();
            pay.openWindowPay();
            let payFormReminder = $("#payment-reminder");
            payFormReminder.submit();
        });
        let paymentReminder = $("#payment-reminder");

        if (paymentReminder) {
            paymentReminder.on("submit", function(e) {
                e.preventDefault();
                let form = document.getElementById("payment-reminder");
                let orderId = form.getAttribute("data-item");

                if (orderId) {
                    pay.pay(orderId);
                }
            });
        }

        let paymentCancel = document.getElementById("payment-cancel-order");

        if (paymentCancel) {
            paymentCancel.addEventListener("click", function(e) {
                e.preventDefault();
                let form = document.getElementById("payment-reminder");
                let orderId = form.getAttribute("data-item");
                if (orderId) {
                    pay.orderCancel(orderId);
                }
            });
        }
    }
})(jQuery);
//